export class NumberTool {
    static convertToString = (num: number, size: number) => {
        var s = "00000000000" + num;
        return s.substring(s.length-size);
    }
}